/** Strings of the campaign screens; merged into `ca` by src/i18n/ca.ts. */
export const ca_campaign = {
  campaignPage: {
    kicker: 'Campanya',
    territory: 'Territori',
    nextSession: 'Pròxima sessió',
    openSession: 'Obre la sessió',
    noNextSession: 'Encara no hi ha cap sessió del capítol següent.',
    noNextSessionGenerate:
      'Encara no hi ha cap sessió del capítol següent: genera’l des del botó de dalt.',
    nextVote: 'Votació del capítol següent',
    nextVotePending: 'Cap votació oberta per al capítol següent.',
    goToDecide: 'Ves a «Decideix»',
    participants: (n: number) => (n === 1 ? '1 participant' : `${n} participants`),
    share: 'Comparteix',
  },
  profilePage: {
    sessionsPlayed: 'Sessions jugades',
    missionsMade: 'Missions fetes',
    attendance: 'Assistències',
    tabPlayed: 'Jugades',
    playedTitle: 'Sessions on has jugat',
    matchesTitle: 'Partides al panell',
    matchesEmpty: 'Cap partida enllaçada encara.',
    notCounted: 'no compta',
    notCountedHint:
      'Una prova de la plataforma o una partida descartada: surt a la llista, però no a les xifres de dalt.',
    directedTitle: 'Sessions dirigides',
    medalsEmpty: 'Cap medalla encara.',
    avatarPending: 'Avatar',
    timePlayed: (h: number, m: number) => `${h}h ${String(m).padStart(2, '0')}m`,
  },
};
